import React from "react";
import { Link } from "react-router-dom";
import { convertTimezone } from "../../lib/utils";
const getNewsColumns = (deleteFunc) => {
  return [
    {
      title: "Image",
      render: (text, record) => <img src={record.image} />,
      width: "10%",
    },
    {
      title: "Title",
      dataIndex: "title",
      sorter: (a, b) => a.title.length - b.title.length,
      render: (text, record) => text.substring(0, 80),
      // style: { overflow: "visible" },
      width: "70%",
    },
    {
      title: "Created At",
      render: (text, record) => <div>{convertTimezone(record.createdAt)}</div>,
      width: "15%",
    },
    {
      title: "Action",
      className: "text-end",
      render: (text, record) => (
        <div className="dropdown dropdown-action text-end">
          <Link
            to="#"
            className="action-icon dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="material-icons">more_vert</i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link className="dropdown-item" to={`/news_action/${record.id}`}>
              <i className="fa fa-pencil m-r-5" /> Edit
            </Link>
            <button
              className="dropdown-item"
              onClick={() => deleteFunc(record.id)}
            >
              <i className="fa fa-trash m-r-5" /> Delete
            </button>
          </div>
        </div>
      ),
      width: "15%",
    },
  ];
};

export default getNewsColumns;
